const Texts = {
  CHECK_API_CALL: 'Check api call',
  GET_NOTIFCATION: 'Get notification'
}

export default Texts

